/// <reference types="@types/googlepay" />
import type { Customer, PaymentMethod } from '@/types/checkout';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import type { StripePaymentRequest, StripePaymentParams } from '@/types/payment';

export const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export const buildStripePaymentRequest = (
  providerSettings: PaymentMethod,
  customer: Customer
): Omit<StripePaymentRequest, 'params'> & { params: Partial<StripePaymentParams> } => {
  return {
    paymentProvider: providerSettings.provider,
    paymentMethodId: providerSettings.paymentMethodName,
    paymentMethodDisplayName: providerSettings.paymentMethodName,
    receipt_email: customer.email ?? '',
    params: {},
  };
};

export const REQUIRED_CVC_PROVIDERS = [ProviderEnum.ADYEN, ProviderEnum.NUVEI];

export const shouldShowApprovalTextForPaymentMethod = (paymentMethodSelected: PaymentMethodEnum) => {
  return paymentMethodSelected !== PaymentMethodEnum.CREDIT_CARD && paymentMethodSelected !== PaymentMethodEnum.OTHER;
};
